import { OPERATE_TYPE, SDK_EVENT, KV, ROLE_TYPE } from './common/Constant';
import API from './message/API';
import log from 'loglevel';
import { deepCopy } from './utils/utils';
import VhyReporter from '@vhallyun/log-reporter';
/**
 * 操作
 *
 * @export
 * @class OperateKit
 */
export default class OperateKit {
  constructor(app) {
    this._app = app;
    this.api = new API(this._app);
    this.store = this._app.store;

    this._msgTemplate = {
      role: this.store.getKV(KV.ROLE),
      userId: this.store.getKV(KV.THIRD_PARTY_USER_ID),
      permission: this.store.getKV(KV.PERMISSION),
      hash: '',
      uniqueID: Date.now(),
      currentPage: 0,
      page: 0,
      currentStep: 0,
      step: 0,
      cw: 300,
      ch: 150,
      width: 300,
      height: 150,
      cid: '',
      ext: '',
      version: process.env.VERSION,
      doc_type: 2,
      command: [],
      flipOver: 0,
      docId: '',
      pf: 'js'
    };

    this._commandTemplate = {
      type: '',
      data: {},
      stamp: Date.now(),
      event: 'operate'
    };
    this.isVod = this.store.getKV(KV.IS_VOD);
  }

  init(params) {
    return this.api.init(params);
  }

  createDocument(obj) {
    return new Promise(async (resolve, reject) => {
      const { noDispatch } = obj;
      const roleType = this.store.getKV(KV.ROLE);
      let able = roleType === ROLE_TYPE.HOST;
      if (!able || noDispatch || this.isVod) {
        resolve();
        return;
      }

      // id, width, height
      const { id, width, height, docId, docType } = obj;
      log.info('发送创建文档请求');
      let commandTemplate = deepCopy(this._commandTemplate);
      let msgTemplate = deepCopy(this._msgTemplate);
      commandTemplate.type = OPERATE_TYPE.CREATE_CONTAINER;
      commandTemplate.op = OPERATE_TYPE.CREATE_CONTAINER;
      commandTemplate.is_board = 1;
      commandTemplate.stamp = Date.now();
      commandTemplate.data = {
        id,
        width,
        height,
        docId,
        type: 'document'
      };
      commandTemplate.userId = this.store.getKV(KV.THIRD_PARTY_USER_ID);
      msgTemplate.command = [commandTemplate];
      msgTemplate.uniqueID = Date.now();
      msgTemplate.cid = id;
      msgTemplate.cw = width;
      msgTemplate.ch = height;
      msgTemplate.docId = docId;
      if (docType === 1 || docType === 2) {
        msgTemplate.doc_type = docType;
      }
      await this.api.emitMessage(msgTemplate);
      resolve();
    });
  }

  async createBoard(obj) {
    const roleType = this.store.getKV(KV.ROLE);
    let able = roleType === ROLE_TYPE.HOST;
    const { noDispatch } = obj;
    if (!able || noDispatch || this.isVod) return;
    // id,width,height,backgroundColor
    const { id, width, height, backgroundColor } = obj;
    log.info('发送创建白板请求');
    let commandTemplate = deepCopy(this._commandTemplate);
    let msgTemplate = deepCopy(this._msgTemplate);
    commandTemplate.type = OPERATE_TYPE.CREATE_CONTAINER;
    commandTemplate.op = OPERATE_TYPE.CREATE_CONTAINER;
    commandTemplate.is_board = 2;
    commandTemplate.stamp = Date.now();
    commandTemplate.data = {
      id,
      width,
      height,
      backgroundColor,
      type: 'board'
    };
    commandTemplate.userId = this.store.getKV(KV.THIRD_PARTY_USER_ID);
    msgTemplate.command = [commandTemplate];
    msgTemplate.uniqueID = Date.now();
    msgTemplate.cid = id;
    msgTemplate.cw = width;
    msgTemplate.ch = height;
    await this.api.emitMessage(msgTemplate);
    return Promise.resolve();
  }

  destroy({ id, docId }) {
    const roleType = this.store.getKV(KV.ROLE);
    let able = roleType === ROLE_TYPE.HOST;
    if (!able || this.isVod) return;
    log.info(`销毁sdk实例，id:${id}`);
    let commandTemplate = deepCopy(this._commandTemplate);
    let msgTemplate = deepCopy(this._msgTemplate);
    commandTemplate.type = OPERATE_TYPE.DELETE_CONTAINER;
    commandTemplate.op = OPERATE_TYPE.DELETE_CONTAINER;
    commandTemplate.stamp = Date.now();
    commandTemplate.data = {
      id
    };
    commandTemplate.userId = this.store.getKV(KV.THIRD_PARTY_USER_ID);
    msgTemplate.command = [commandTemplate];
    msgTemplate.uniqueID = Date.now();
    msgTemplate.cid = id;
    msgTemplate.docId = docId;
    this.api.emitMessage(msgTemplate);
  }

  select(id, param) {
    const roleType = this.store.getKV(KV.ROLE);
    let able = roleType === ROLE_TYPE.HOST;
    if (!able || this.isVod) return Promise.resolve();
    log.info(`选中实例,id:${id}`);
    let commandTemplate = deepCopy(this._commandTemplate);
    let msgTemplate = deepCopy(this._msgTemplate);
    commandTemplate.type = OPERATE_TYPE.SELECT_CONTAINER;
    commandTemplate.op = OPERATE_TYPE.SELECT_CONTAINER;
    commandTemplate.stamp = Date.now();
    commandTemplate.data = { id };
    if (param.docId) commandTemplate.data.docId = param.docId;
    commandTemplate.is_board = id.indexOf('document') > -1 ? 1 : 2;
    commandTemplate.userId = this.store.getKV(KV.THIRD_PARTY_USER_ID);
    msgTemplate.command = [commandTemplate];
    msgTemplate.uniqueID = Date.now();
    msgTemplate.cid = id;
    // msgTemplate.docId = this.store.getKV(KV.DOC_ID) || '';
    if (param) {
      msgTemplate.cw = param.cw;
      msgTemplate.ch = param.ch;
      msgTemplate.width = param.width;
      msgTemplate.height = param.height;
      msgTemplate.backgroundColor = param.backgroundColor;
    }
    return this.api.emitMessage(msgTemplate);
  }

  switchOn(id = '') {
    const roleType = this.store.getKV(KV.ROLE);
    let able = roleType === ROLE_TYPE.HOST;
    if (!able || this.isVod) return;
    log.info(`开启观看端演示.id:${id}`);
    let commandTemplate = deepCopy(this._commandTemplate);
    let msgTemplate = deepCopy(this._msgTemplate);
    commandTemplate.type = OPERATE_TYPE.SWITCH_ON;
    commandTemplate.op = OPERATE_TYPE.SWITCH_ON;
    commandTemplate.stamp = Date.now();
    commandTemplate.data = { id: id };
    commandTemplate.userId = this.store.getKV(KV.THIRD_PARTY_USER_ID);
    msgTemplate.command = [commandTemplate];
    msgTemplate.uniqueID = Date.now();
    this.api.emitMessage(msgTemplate);
  }

  switchOff(id = '') {
    const roleType = this.store.getKV(KV.ROLE);
    let able = roleType === ROLE_TYPE.HOST;
    if (!able || this.isVod) return;
    log.info(`关闭观看端演示.id:${id}`);
    let commandTemplate = deepCopy(this._commandTemplate);
    let msgTemplate = deepCopy(this._msgTemplate);
    commandTemplate.type = OPERATE_TYPE.SWITCH_OFF;
    commandTemplate.op = OPERATE_TYPE.SWITCH_OFF;
    commandTemplate.stamp = Date.now();
    commandTemplate.data = { id: id };
    commandTemplate.userId = this.store.getKV(KV.THIRD_PARTY_USER_ID);
    msgTemplate.command = [commandTemplate];
    msgTemplate.uniqueID = Date.now();
    this.api.emitMessage(msgTemplate);
  }

  getContainerInfo(opts) {
    log.info('获取当前appid 对应的 channelId 下的文档容器信息列表');
    return this.api.getWatchInfo(opts);
  }

  resetContainerInfo() {
    const roleType = this.store.getKV(KV.ROLE);
    // 上报日志
    VhyReporter.scout(260156, { roleType });

    let able = roleType === ROLE_TYPE.HOST;
    if (!able || this.isVod) return;
    log.info('重置当前appid 对应的channelId 下的容器信息');
    this.api.resetContainer();
  }

  sendMsg(str) {
    let roleType = this.store.getKV(KV.ROLE);
    let able = roleType === ROLE_TYPE.HOST || roleType === ROLE_TYPE.ASSISTANT || roleType === ROLE_TYPE.GUEST;
    if (!able) return;
    if (this.isVod) return;
    let currentId = this.store.getKV(KV.CURRENT_DOC_CID);
    let id = (this.currentDoc && this.currentDoc.id) || '';

    if (currentId != id) return;
    if (this._lastMsgStr == str) return;
    this._lastMsgStr = str;
    this.kit.api.emitMessage(str);
  }
  /** 上报章节信息，绑定了 main.js 的 this */
  reportChapters(msg) {
    let role = this.store.getKV(KV.ROLE);
    let able = role === ROLE_TYPE.HOST || role === ROLE_TYPE.ASSISTANT || role === ROLE_TYPE.GUEST;
    if (!able) return;
    if (this.store.getKV(KV.ISRELAY)) return;
    if (this.isVod || this.store.getKV(KV.ISRELAY)) return;
    const {
      cid,
      doc_type,
      event,
      params: { hash, docId, slideIndex, stepIndex }
    } = msg;
    let title;
    try {
      /** 有可能出现有步骤但是没标题情况，所以如果标题读不到，就不发送章节信息 */
      title =
        event == 'onSlideChange'
          ? this.currentDoc.store.getKV('chapters')[slideIndex].title
          : this.currentDoc.store.getKV('chapters')[slideIndex]['subsection'][stepIndex - 1 ? stepIndex - 1 : 0].title;
    } catch (error) {
      return;
    }
    const param = {
      hash,
      docId,
      cid,
      op: event == 'onSlideChange' ? 'filpover' : 'stepupdate',
      doc_type,
      page: slideIndex,
      step: stepIndex,
      version: process.env.VERSION,
      title,
      remark: ''
    };
    this.kit.api.reportChapters(param);
  }
  /**
   * 翻页消息上报
   * http://wiki.vhallops.com/pages/viewpage.action?pageId=2491743
   */
  reportPageChange(obj) {
    let currentId = this.store.getKV(KV.CURRENT_DOC_CID);
    let id = (this.currentDoc && this.currentDoc.id) || '';
    if (currentId !== id) {
      return;
    }
    log.info('OperateKit reportPageChange');
    let pageInfo = { id: obj.cid, info: obj.doc };
    if (obj.cid == id) this.emit(SDK_EVENT.PAGE_CHANGE, pageInfo);
    let docID = obj.doc.docId;
    let reportData = {
      uid: this.store.getKV(KV.THIRD_PARTY_USER_ID) || '',
      doc_id: docID || '',
      app_id: this.store.getKV(KV.APP_ID) || '',
      vfid: this.store.getKV(KV.VFID) || '',
      service_names: Number(this.store.getKV(KV.IS_VOD)) + 1,
      share_times: 1,
      view_type: this.store.getKV(KV.ROLE) === 1 ? 1 : 2,
      bu: this.store.getKV(KV.BU) || 1,
      page_number: obj.doc['slideIndex'],
      s: this.store.getKV(KV.THIRD_PARTY_USER_ID) + Date.now().toString(),
      userId: this.store.getKV(KV.THIRD_PARTY_USER_ID)
    };
    // 翻页上报
    VhyReporter.scout(262001, reportData);
  }
  getDocInfo(obj) {
    const { docId } = obj;
    log.info('获取文档信息: ', docId);
    return this.api.getDocInfo(docId);
  }
  getVodData(url) {
    return this.api.getVodData(url);
  }
  async getChapters(docId) {
    const [chapters = []] = await this.api.getChapters(docId);
    return Promise.resolve(chapters);
  }
  /**
   * 断流消息重推
   *
   * @examples http://yapi.vhall.domain/project/26/interface/api/6135
   */
  republish() {
    return this.api.republish();
  }
  /**
   * 接口文档：http://yapi.vhall.domain/project/59/interface/api/19413
   */
  start(state = 1, type = 1) {
    let obj = {
      lss_type: state,
      lss_flag: type,
      lss_id: this.store.getKV(KV.ROOM_ID)
    };
    return this.api.start(obj);
  }
  destroyKit() {
    this.api.destroy();
    this.api = null;
  }
}
